import React from 'react';
import restingTrend from '../assets/market-state/pinngro-resting-trend.png';
import workingTrend from '../assets/market-state/pinngro-working-trend.png';
import restingMomentum from '../assets/market-state/pinngro-resting-momentum.png';
import workingMomentum from '../assets/market-state/pinngro-working-momentum.png';
import restingReversion from '../assets/market-state/pinngro-resting-reversion.png';
import workingReversion from '../assets/market-state/pinngro-working-reversion.png';
import restingCrossover from '../assets/market-state/pinngro-resting-crossover.png';
import workingCrossover from '../assets/market-state/pinngro-working-crossover.png';
import restingBreakdown from '../assets/market-state/pinngro-resting-breakdown.png';
import workingBreakdown from '../assets/market-state/pinngro-working-breakdown.png';
import restingExperiment from '../assets/market-state/pinngro-resting-experiment.png';
import workingExperiment from '../assets/market-state/pinngro-working-experiment.png';
import restingClassic from '../assets/market-state/pinngro-resting-classic.png';
import workingClassic from '../assets/market-state/pinngro-working-classic.png';
import restingCustom from '../assets/market-state/pinngro-resting-custom.png';
import workingCustom from '../assets/market-state/pinngro-working-custom.png';
import restingZzzTrend from '../assets/market-state/pinngro-resting-zzz-trend.webp';
import restingZzzMomentum from '../assets/market-state/pinngro-resting-zzz-momentum.webp';
import restingZzzReversion from '../assets/market-state/pinngro-resting-zzz-reversion.webp';
import restingZzzCrossover from '../assets/market-state/pinngro-resting-zzz-crossover.webp';
import restingZzzBreakdown from '../assets/market-state/pinngro-resting-zzz-breakdown.webp';
import restingZzzExperiment from '../assets/market-state/pinngro-resting-zzz-experiment.webp';
import restingZzzClassic from '../assets/market-state/pinngro-resting-zzz-classic.webp';
import restingZzzCustom from '../assets/market-state/pinngro-resting-zzz-custom.webp';

const illustrations = {
  trend: { resting: restingTrend, restingMotion: restingZzzTrend, working: workingTrend },
  momentum: { resting: restingMomentum, restingMotion: restingZzzMomentum, working: workingMomentum },
  reversion: { resting: restingReversion, restingMotion: restingZzzReversion, working: workingReversion },
  crossover: { resting: restingCrossover, restingMotion: restingZzzCrossover, working: workingCrossover },
  breakdown: { resting: restingBreakdown, restingMotion: restingZzzBreakdown, working: workingBreakdown },
  experiment: { resting: restingExperiment, restingMotion: restingZzzExperiment, working: workingExperiment },
  classic: { resting: restingClassic, restingMotion: restingZzzClassic, working: workingClassic },
  custom: { resting: restingCustom, restingMotion: restingZzzCustom, working: workingCustom },
};

// BotPresence supplies the authoritative state and existing strategy-family identity.
// Artwork is decorative; its colour does not encode operational status.
export default function MarketStateMascot({ state, family }) {
  const variant = Object.hasOwn(illustrations, family) ? family : 'custom';
  if (state === 'resting') return <picture className="market-state-mascot-frame">
    <source media="(prefers-reduced-motion: no-preference)" type="image/webp" srcSet={illustrations[variant].restingMotion} />
    <img
      className="market-state-mascot"
      src={illustrations[variant].resting}
      width="320"
      height="281"
      alt=""
      draggable="false"
      decoding="async"
    />
  </picture>;
  return <img
    className="market-state-mascot"
    src={illustrations[variant][state]}
    width="320"
    height="257"
    alt=""
    draggable="false"
    decoding="async"
  />;
}
